// Vuetify
import { createVuetify } from "vuetify"
import { aliases, mdi } from "vuetify/iconsets/mdi"
import { customSVGs } from "../iconsets/custom"

// Styles
import "@mdi/font/css/materialdesignicons.css"
import "../styles/vuetify-overrides.scss"

export const vuetify = createVuetify({
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
      custom: customSVGs,
    }
  },
  theme: {
    themes: {
      light: {
        colors: {
          "on-surface": "#222222",
        },
        variables: {
          "high-emphasis-opacity": 1
        }
      }
    }
  }
})
